/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppointmentCalendar } from '../../models/appointment-calendar';

export interface FindAppointments$Params {
  dateFrom: string;
  dateTo: string;
  bookId: string;
  resourceIds?: Array<string>;
  withNoResource?: boolean;
}

export function findAppointments(http: HttpClient, rootUrl: string, params: FindAppointments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppointmentCalendar>>> {
  const rb = new RequestBuilder(rootUrl, findAppointments.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('bookId', params.bookId, {});
    rb.query('resourceIds', params.resourceIds, {});
    rb.query('withNoResource', params.withNoResource, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppointmentCalendar>>;
    })
  );
}

findAppointments.PATH = '/api/appointments';
